import { CalendarSearch, Ticket, PartyPopper, Repeat } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const steps = [
  { i: 1, icon: CalendarSearch, title: "Pick a night", body: "Browse the schedule — themed parties, game nights, couples events, speed dating, holiday socials, and more. Every event is planned and hosted by us." },
  { i: 2, icon: Ticket, title: "Grab your ticket", body: "Secure checkout in a few taps. You'll get everything you need — venue, dress code, arrival details — right in your inbox." },
  { i: 3, icon: PartyPopper, title: "Show up offline", body: "Our host runs the room so you don't have to. Just come as you are, meet people who left the couch too, and enjoy the night." },
  { i: 4, icon: Repeat, title: "Come back for the next one", body: "New events drop every season. Save events, get reminders, and follow along on socials so you never miss the next great night." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-20" data-testid="how-it-works-page">
      <div className="max-w-3xl mb-16">
        <div className="text-eyebrow">What we do</div>
        <h1 className="font-heading text-5xl md:text-6xl mt-4">Great nights, already planned.</h1>
        <p className="text-neutral-600 mt-6 leading-relaxed text-lg">
          Offline &amp; Available is an event brand for adults. We produce social experiences — themed parties, game nights, couples events, speed dating, holiday socials — designed so all you have to do is show up. Here's how it works.
        </p>
      </div>
      <div className="space-y-14">
        {steps.map(s => (
          <div key={s.i} className="grid md:grid-cols-12 gap-6 md:gap-10 items-start" data-testid={`hiw-step-${s.i}`}>
            <div className="md:col-span-3 font-heading text-6xl gold">{String(s.i).padStart(2,"0")}</div>
            <div className="md:col-span-9 card-elegant p-8 md:p-10">
              <s.icon className="text-neutral-400" size={26} strokeWidth={1.5} />
              <h2 className="font-heading text-3xl mt-4">{s.title}</h2>
              <p className="mt-4 text-neutral-600 leading-relaxed">{s.body}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-20 flex flex-wrap justify-center gap-3">
        <Link to="/events"><Button className="rounded-full bg-black text-white hover:bg-neutral-800 btn-pill" data-testid="hiw-cta-events">See upcoming events</Button></Link>
        <Link to="/signup"><Button variant="outline" className="rounded-full btn-pill" data-testid="hiw-cta-signup">Create an account</Button></Link>
      </div>
    </div>
  );
}
